import api from './axios'

// 로그 기록
export const sendEventLog = async(eventData) => {
  const res = await api.post("users/userlog", eventData)
  return res.data
}